export const MICROAPP_NAME = "dashboards-core-service";

export const MAIN_ROUTE = "/dashboards";

export const FIXED_DASHBOARDS = ["/health", "sase-health", "threat_insights_report", "prismasdwan"];

export const WAIT_FOR_DASHBOARD_LOADING_DELAY = 5000;

export const MAX_CUSTOM_DASHBOARDS = 10;
